import { createRoute } from '@tanstack/react-router'

import { OrderCopyRoute } from '../pages/OrderCopyRoute'
import { orderRoute } from './OrderRoute'

export const orderCopyRoute = createRoute({
  getParentRoute: () => orderRoute,
  component: () => <OrderCopyRoute />,
  path: '/copy/$id'
})
